import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';
import getChannelInfo from './utils/channel-details';
import { Base64 } from 'js-base64';
import { DOWNTIME_TYPE, AVALOQ_ALERT_ID} from '../constants';
import { AsyncStorage } from 'react-native';

export default () => muster()
    .path('alerts.list', {
        call: async ({ req }, { get, set, call }) => {
            const module = req?.args[0];
            const [langCode] = await getValues(get('auth.langCode'));
            const [userId] = await getValues(get('auth.userId'));
            const request = {
                // category: category, // removed in new solution 
                // subCategory: 'UPDATE',
                // featureTag: '',
                ...(module && { module: module }),
                language: langCode,
                // alertId: '',
                userId: userId,
            }
            const requestObj = Base64.encode(JSON.stringify(request));
            const guidStr = Guid();
            const [result] = await
                getValues(
                    get(`roster.data.alerts.list["${requestObj}"]["${guidStr}"]`)
                ); 
            isValidJsonString(result).then(async (data) => {
                if(data){
                    await set('alerts.alertItems', data.alertItems); 
                    data.alertItems.map((obj, i) => {
                        if(obj.alertId === AVALOQ_ALERT_ID){
                            set('alerts.isAvaloqDown', true); 
                            set('alerts.showAvaloqDownBanner', true); 
                        } 
                    })
                }}).catch(async (error) => {
                });
                
                  
        }
    })
    .path('alerts.seenStatus', {
        call: async ({ req }, { get, set, call }) => {
            const [langCode] = await getValues(get('auth.langCode'));
            const [userId] = await getValues(get('auth.userId'));
            const alertDocId =req?.args[2];
            const channelInfo = getChannelInfo();
            const request = {
                userId: userId,
                channel: "WEB",
                channelDetails: channelInfo,
                version: req?.args[3] ? req?.args[3] : 0,
                alertId: req.args[0],
                language: langCode,
                actionDetails: req.args[1],
                ...(alertDocId && {alertDocId: alertDocId})
            }
            const requestObj = Base64.encode(JSON.stringify(request));
            const guidStr = Guid();
            const inputParam = `${requestObj}`;
            const [result] = await
                getValues(
                    get(`roster.data.alerts.seenStatus["${inputParam}"]["${guidStr}"]`)
                ); 
            isValidJsonString(result).then(async (data) => {
                if(data){
                }}).catch(async (error) => {
                });         
        }
    })
    .path('alerts.alertItems', variable({}))
    .path('alerts.isDontShowAgainCheckbox', variable(false))
    .path('alerts.isAlertModalOpen', variable(false))

    .path('banner.getDowntime', { 
        call: async ({ req }, { get, set, call }) => {
            //const [langCode] = await getValues(get('languages.destLanguageCode'));
            const langCode = await AsyncStorage.getItem('SelectedLanguageCode');
             const request = {
                language: langCode ? langCode.substring(0,2) : "en",
            }
            const requestObj = Base64.encode(JSON.stringify(request));
            const guidStr = Guid();
            const inputParam = `${requestObj}`;

            const [downtimeData] = await getValues(get(`roster.data.banner.getDowntime["${inputParam}"]["${guidStr}"]`));
            try{
                const parsedDowntimeData = JSON.parse(downtimeData);
                isValidJsonString(downtimeData).then(() => {
                    set('banner.downtimeData',parsedDowntimeData)
                    if(parsedDowntimeData?.alertItems[0]?.subCategory === DOWNTIME_TYPE.PLANNED)
                    set('banner.plannedDowntime',true);

                    if(parsedDowntimeData?.alertItems[0]?.subCategory === DOWNTIME_TYPE.ACTIVE)
                    set('banner.activeDowntime',true);
                    }).catch((error) => {
                        console.log("error in getting downtime", error)
                    });
                    set('banner.isDowntime', true);
            }
            catch(error){
                 console.log("error in getting downtime", error)
            }
        },
    })
    .path('banner.plannedDowntime', variable(false))
    .path('banner.activeDowntime', variable(false))
    .path('alerts.isAvaloqDown', variable(false))
    .path('alerts.showAvaloqDownBanner', variable(false))
    .path('banner.isDowntime', variable(false))
    .path('banner.downtimeData', variable({}));
